// extracted by mini-css-extract-plugin
module.exports = {"flexRight":"flex-right_flexRight__kMmuI"};